import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function BetalingGeannuleerd() {
  return (
    <div className="min-h-screen bg-oc-bg flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white border border-oc-border rounded-oc p-10 text-center">
        <div className="w-14 h-14 rounded-full bg-oc-high/10 mx-auto flex items-center justify-center">
          <XCircle className="w-7 h-7 text-oc-high" />
        </div>
        <h1 className="mt-5 font-display text-oc-primary text-[26px] font-bold">Betaling geannuleerd</h1>
        <p className="mt-2 text-oc-textSecondary text-[15px] leading-relaxed">
          Geen probleem. Er is niets aangerekend. Je kan de analyse opnieuw starten wanneer je wilt.
        </p>
        <Link to="/analyse">
          <Button data-testid="restart-analysis" className="mt-7 w-full h-12 bg-oc-primary hover:bg-oc-secondary text-white rounded-oc-btn font-semibold">
            Opnieuw starten
          </Button>
        </Link>
      </div>
    </div>
  );
}
